// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"DashboardChart_chartWrapper___g6Ag"};